/* Monaco Design - Global JS Utilities */

class DrawerController {
  constructor() {
    this.overlay = document.getElementById('DrawerOverlay');
    this.drawers = document.querySelectorAll('.drawer');
    this.openButtons = document.querySelectorAll('[data-drawer-target]');
    this.closeButtons = document.querySelectorAll('.drawer__close');

    this.init();
  }

  init() {
    if (!this.overlay) return;

    // Toggle logica per aprire
    this.openButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = btn.getAttribute('data-drawer-target');
        const drawer = document.getElementById(targetId);
        if (drawer && drawer.classList.contains('is-active')) {
          this.closeAllDrawers();
        } else {
          this.openDrawer(targetId);
        }
      });
    });

    // Logica per chiudere
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.closeAllDrawers());
    });

    // Chiudi cliccando l'overlay
    this.overlay.addEventListener('click', () => this.closeAllDrawers());
  }

  openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;

    this.closeAllDrawers(); // Chiudi gli altri eventualmente aperti
    
    drawer.classList.add('is-active');
    this.overlay.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
    drawer.setAttribute('aria-expanded', 'true');
    
    const triggerBtn = document.querySelector(`[data-drawer-target="${id}"]`);
    if(triggerBtn) triggerBtn.classList.add('is-active');
  }

   closeAllDrawers() {
    this.drawers.forEach(drawer => {
      drawer.classList.remove('is-active');
      drawer.setAttribute('aria-expanded', 'false');
    });
    if(this.overlay) this.overlay.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
    
    this.openButtons.forEach(btn => btn.classList.remove('is-active'));
  }
}

class AjaxCartController {
  constructor() {
    this.cartDrawer = document.getElementById('DrawerCart');
    this.initAddForms();
    this.initCartListeners();
  }

  initAddForms() {
    // Intercetta i form di aggiunta al carrello (es. pagina prodotto)
    const addForms = document.querySelectorAll('form[action*="/cart/add"]');
    addForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        const formData = new FormData(form);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(item => {
          this.refreshCartDrawer();
          if (window.drawerController) {
            window.drawerController.openDrawer('DrawerCart');
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          alert('Errore durante l\'aggiunta al carrello.');
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    });
  }

  initCartListeners() {
    if (!this.cartDrawer) return;

    // Usiamo event delegation sul contenitore del carrello per intercettare i click
    this.cartDrawer.addEventListener('click', (e) => {
      // Tasti più e meno
      if (e.target.classList.contains('cart-qty-btn')) {
        const key = e.target.getAttribute('data-key');
        const input = this.cartDrawer.querySelector(`.cart-qty-input[data-key="${key}"]`);
        if (!input) return;

        let qty = parseInt(input.value);
        if (e.target.classList.contains('plus')) {
          qty += 1;
        } else if (e.target.classList.contains('minus')) {
          qty -= 1;
          if (qty < 0) qty = 0;
        }
        this.updateItem(key, qty);
      }

      // Tasto Rimuovi
      const removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        const key = removeBtn.getAttribute('data-key');
        this.updateItem(key, 0);
      }
    });
  }

  updateItem(key, quantity) {
    const inner = this.cartDrawer.querySelector('.drawer__inner');
    if (inner) inner.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      this.updateCartCount(cart.item_count);
      this.refreshCartDrawer();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      if (inner) inner.classList.remove('is-loading');
    });
  }

  refreshCartDrawer() {
    // Usa la Section Rendering API per scaricare solo l'HTML aggiornato del carrello
    fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = parsedHtml.getElementById('DrawerCart');
        if (newDrawer && this.cartDrawer) {
          this.cartDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(error => console.error('Error refreshing cart:', error));
  }

  updateCartCount(count) {
    const bubbles = document.querySelectorAll('.cart-count-bubble span');
    if (count > 0) {
      if (bubbles.length > 0) {
        bubbles.forEach(span => span.textContent = count);
      } else {
        // Se la bubble non esiste, dovremmo crearla, oppure refreshando la pagina.
        // Ma visto che abbiamo il refresh del drawer, in header si ricaricherà?
        // No, l'header non si ricarica. Dobbiamo iniettare la bubble se manca.
        const cartIcons = document.querySelectorAll('[data-drawer-target="DrawerCart"]');
        cartIcons.forEach(icon => {
          if (!icon.querySelector('.cart-count-bubble')) {
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = `<span aria-hidden="true">${count}</span>`;
            icon.appendChild(bubble);
          }
        });
      }
    } else {
      // Se 0, rimuoviamo le bolle
      const bubbleContainers = document.querySelectorAll('.cart-count-bubble');
      bubbleContainers.forEach(el => el.remove());
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.drawerController = new DrawerController();
  window.ajaxCartController = new AjaxCartController();
});
